import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, Form, FormGroup, Input, Label, Row, Col, Alert } from 'reactstrap';
import * as actions from '../actions/Grant';
import moment from 'moment';
import { getOptions } from '../utils';
import Breadcrumb from '../components/AdminBreadcrumb';

class Grant extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showEndDateBeforeStartDate: false
        };
    }

    componentDidMount() {
        const programId = parseInt(this.props.match.params.id, 10);
if (!isNaN(programId)) {
    this.props.actions.getGrant(programId);
}
    }

    handleSave = () => {
        const { endDate, name, startDate } = this.props.grant.toJS();

        const grantStartDate = startDate ? moment(startDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.startDate).format(moment.HTML5_FMT.DATE)

        const grantEndDate = endDate ? moment(endDate).format(moment.HTML5_FMT.DATE) :
            moment(this.props.endDate).format(moment.HTML5_FMT.DATE)

        this.setState({ showEndDateBeforeStartDate: false });

        if (grantEndDate < grantStartDate) {
            this.setState({ showEndDateBeforeStartDate: true });
        }
        else if (name) {
            const programId = this.props.history?.location?.state?.fromProgramId || null
            this.props.actions.updateGrant(this.props.grant, programId);
            this.setState({ showEndDateBeforeStartDate: false });
            if(programId)
            this.props.history.push({
                pathname: `/programs/program/${programId}`,
                state: { programId: programId }
            });
            else
                this.props.history.push({pathname: '/grants/'});
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.props.actions.setField(this.props.currentSessionId, name, value);
    }

    render() {

        const { grantManager, grantType, name, number, startDate, endDate } = this.props.grant.toJS();

        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Alert color="warning" isOpen={this.state.showEndDateBeforeStartDate} fade={true}>
                    Grant end date cannot occur before grant start date
                </Alert>
                <Form>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Name:</Label>
                                <Input name='name' invalid={!name} onChange={this.handleChange} required value={name || ''} />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Number:</Label>
                                <Input name='number' onChange={this.handleChange} value={number || ''} />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Grant Type:</Label>
                                <Input
                                    type='select'
                                    name='grantType'
                                    value={grantType || ''}
                                    onChange={this.handleChange}
                                >
                                    {getOptions(this.props.grantTypes, true)}
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>BJA Grant Manager:</Label>
                                <Input name='grantManager' onChange={this.handleChange} value={grantManager || ''} />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>Start Date:</Label>
                                <Input type='date' name='startDate' onChange={this.handleChange} value={moment(startDate).format('YYYY-MM-DD')} />
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>End Date:</Label>
                                <Input type='date' name='endDate' onChange={this.handleChange} value={moment(endDate).format('YYYY-MM-DD')} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button className={'float-right'} disabled={!name} onClick={this.handleSave}>Save</Button>
                        </Col>
                    </Row>
                </Form >
            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        grant: state.Grant,
        currentSessionId: parseInt(state.login.getIn(['context', 'user', 'claims'])
            .find(x => x.get('claimType') === 'ACT.CurrentSession').get('claimValue'), 10)
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Grant);